import { BFIExperienceActionType } from '../ExperienceConstants';
import { LoanType } from '../../../loans/common/LoanConstants';

export const getBFIExperienceActions = (experience: { id: number; loanId: number; loanTypeId: LoanType }, location: Location) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const actions: any[] = [];

    actions.push({
        id: BFIExperienceActionType.ViewExperience,
        text: 'View Experience',
        experienceId: experience.id,
        loanId: experience.loanId,
        loanTypeId: experience.loanTypeId,
        stylingMode: 'contained',
    });

    actions.push({
        id: BFIExperienceActionType.ViewLoan,
        text: 'View Loan',
        experienceId: experience.id,
        loanId: experience.loanId,
        loanTypeId: experience.loanTypeId,
        location,
        stylingMode: 'contained',
    });

    return actions;
};
